import React from 'react'
import { useTranslation } from 'react-i18next';

/**
 * Station Tickets
 * @returns 
 */
function StationTickets() {
  const { t } = useTranslation('stationManagement');
  return (
    <div>
      {t('stationTickets')}
    </div>
  )
}

export default StationTickets
